import gql from 'graphql-tag'

export const CHOICE_INFO = gql`
  query ChoiceInfo($choiceId: Int!) {
    choiceInfo(choiceId: $choiceId)
  }
`
